<div class="tyc-container responsive-padding-s">
    <!-- Logo/App header -->
    <!--     <h3 class="h2-bold text-secondary tyc-title">Te damos la bienvenida
    </h3> -->
    <div class="tyc-header">
        <img src="assets/icons/logo/192.png" alt="Remateriar" class="tyc-logo">
        <span class="h1-bold color-primary tyc-title">
            Remateriar
        </span>
    </div>

    <!-- Language Selector -->
    <div class="tyc-lang-row">
        <app-language-selector></app-language-selector>
    </div>

    <!-- Title -->

    <!-- Description -->
    <h3 class="h3-semibold text-secondary tyc-description">
        <h3 class="h3-semibold text-secondary tyc-description">
            {{ 'tyc.welcomeIntro' | t }}
            <span class="h3-bold">{{ 'tyc.communityTransforms' | t }} </span>
            {{ 'tyc.materialsAndKnowledge' | t }}

        </h3>
        <h3 class="h3-semibold text-secondary tyc-description">
            {{ 'tyc.weAre' | t }}
            <span class="h3-bold">{{ 'tyc.convinced' | t }} </span>
             {{ 'tyc.changeTogether' | t }} <br class="padding-s">
        </h3>
        <h3 class="h3-semibold text-secondary tyc-description">
            {{ 'tyc.publicInfoLine' | t }}
        </h3>
    </h3>

    <!-- Checkboxes -->
    <div class="tyc-checkboxes">
        <!-- Checkbox 1: Terms and Privacy -->
        <label class="tyc-checkbox-label">
            <div class="checkbox-wrapper" (click)="toggleTerms()">
                <div class="custom-checkbox" [class.checked]="termsAccepted()">
                    @if (termsAccepted()) {
                    <img src="assets/icons/check.svg" alt="" class="check-icon icon-white">
                    }
                </div>
            </div>
            <span class="checkbox-text b">
              @if (isDesktopViewport()) {
                {{ 'tyc.acceptThe' | t }} <a class="tyc-inline-link" (click)="onTermsClick($event)">{{ 'tyc.termsOfService' | t }}</a> {{ 'tyc.andThe' | t }}
                <a class="tyc-inline-link" (click)="onPrivacyClick($event)">{{ 'tyc.privacyPolicy' | t }}</a>
              } @else {
                {{ 'tyc.acceptTermsMobile' | t }} <a class="tyc-inline-link" (click)="onTermsClick($event)">{{ 'tyc.termsAndPrivacyMobile' | t }}</a>
              }
            </span>
        </label>

        <!-- Checkbox 2: Cookies -->
<!--         <label class="tyc-checkbox-label" (click)="toggleCookies()">
            <div class="checkbox-wrapper">
                <div class="custom-checkbox" [class.checked]="cookiesAccepted()">
                    @if (cookiesAccepted()) {
                    <img src="assets/icons/check.svg" alt="" class="check-icon icon-white">
                    }
                </div>
            </div>
            <span class="checkbox-text b">Habilitar cookies de seguimiento para marketing y publicidad</span>
        </label> -->
        
        <!-- Cookies escenciales-->
        <label class="tyc-checkbox-label" >
            <span class="checkbox-text b">{{ 'tyc.cookiesNotice' | t }}</span>
        </label>
    </div>

    <!-- Continue Button -->
    <div class="tyc-actions">
        <button class="push-btn primary-color-button btn-m full-width-button" [class.disabled]="!canContinue()"
            [disabled]="!canContinue()" (click)="onContinue()">
            <div class="inner-button">
                <span class="btn-text p-semibold">{{ 'tyc.continue' | t }}</span>
            </div>
        </button>
    </div>
</div>